"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    return {
        textLeft: { textAlign: "left" },
        textCenter: { textAlign: "center" },
        textRight: { textAlign: "right" },
        textNoWrap: { whiteSpace: "nowrap" },
        ellipsis: { textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }
    };
});
//# sourceMappingURL=TextAlignment.js.map